import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useChangeStatusWorkers, useMutateDeleteUser } from '../features/user/hooks';

const DeleteModal = ({ open, setOpen, deleteAction , message }: any) => {
    return (
        <>
            <Dialog
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Delete Confirmation"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                   { message? message : 'Are you sure you want to delete this user?'}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=> setOpen(false)}
                     sx={{
                        "&:hover": {
                          backgroundColor: "#f0f0f0",
                        },
                      }}          
                    >Cancel</Button>
                    <Button onClick={() => {
                        deleteAction()
                        setOpen(false)
                        }}autoFocus
                     sx={{
                        "&:hover": {
                          backgroundColor: "#f0f0f0",
                        },
                      }}          
                   >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default DeleteModal